
import Document from "https://cdn.jsdelivr.net/npm/flexsearch@0.8.105/dist/module/document.js";
import Charset from "https://cdn.jsdelivr.net/npm/flexsearch@0.8.105/dist/module/charset.js";

const ugSteps = $('.ug-step-parent');
let ugItems = [];
let flexIndex;

const choosenCharset = Charset.LatinAdvanced;

const normalizeWithEncoder = (str) => {
    if (!str) return '';
    const lower = str.toLowerCase();
    return typeof choosenCharset === 'function' ? choosenCharset(lower) : lower;
};

const levenshteinDistance = (a, b) => {
    const m = a.length;
    const n = b.length;

    if (!m) return n;
    if (!n) return m;

    const dp = Array.from({ length: m + 1 }, () => new Array(n + 1));

    for (let i = 0; i <= m; i++) dp[i][0] = i;
    for (let j = 0; j <= n; j++) dp[0][j] = j;

    for (let i = 1; i <= m; i++) {
        for (let j = 1; j <= n; j++) {
            const cost = a[i - 1] === b[j - 1] ? 0 : 1;
            dp[i][j] = Math.min(
                dp[i - 1][j] + 1,
                dp[i][j - 1] + 1,
                dp[i - 1][j - 1] + cost
            );
        }
    }

    return dp[m][n];
};

const findApproxMatchesInText = (text, tokens, maxDistance = 1) => {
    const encodedText = normalizeWithEncoder(text);
    if (!tokens.length || !encodedText.length) return [];

    const matches = [];

    tokens.forEach(token => {
        const encodedToken = normalizeWithEncoder(token);
        const tLen = encodedToken.length;
        if (tLen < 3 || encodedText.length < tLen) return;

        for (let i = 0; i <= encodedText.length - tLen; i++) {
            const candidate = encodedText.slice(i, i + tLen);
            const dist = levenshteinDistance(encodedToken, candidate);
            if (dist <= maxDistance) {
                matches.push({
                    start: i,
                    end: i + tLen
                });
            }
        }
    });

    if (!matches.length) return [];

    matches.sort((a, b) => a.start - b.start || a.end - b.end);

    const merged = [];
    let current = matches[0];

    for (let i = 1; i < matches.length; i++) {
        const next = matches[i];
        if (next.start <= current.end) {
            current.end = Math.max(current.end, next.end);
        } else {
            merged.push(current);
            current = next;
        }
    }
    merged.push(current);

    return merged;
};

const clearHighlights = () => {
    ugSteps.each(function () {
        const step = $(this);
        const titleEl = step.find('.ug-step-title');
        const paragraphs = step.find('p:not([class])');

        titleEl.html(titleEl.text());
        paragraphs.each(function () {
            const p = $(this);
            p.html(p.text());
        });
    });
};

const highlightWithApproxMatches = (element, tokens) => {
    const originalText = element.text();
    if (!originalText || !tokens.length) return;

    const ranges = findApproxMatchesInText(originalText, tokens);
    if (!ranges.length) return;

    let result = '';
    let lastIndex = 0;

    ranges.forEach(({ start, end }) => {
        result += originalText.slice(lastIndex, start);
        const segment = originalText.slice(start, end);
        result += `<mark>${segment}</mark>`;
        lastIndex = end;
    });

    result += originalText.slice(lastIndex);
    element.html(result);
};

const applyHighlights = (items, query) => {
    const tokens = query
        .split(/\s+/)
        .map(t => t.trim())
        .filter(t => t.length >= 3);

    if (!tokens.length) return;

    items.forEach(item => {
        const step = item.element;
        const titleEl = step.find('.ug-step-title');
        const paragraphs = step.find('p:not([class])');

        highlightWithApproxMatches(titleEl, tokens);
        paragraphs.each(function () {
            highlightWithApproxMatches($(this), tokens);
        });
    });
};

const initUGItems = () => {
    ugItems = [];
    ugSteps.each(function (index) {
        const step = $(this);

        const title = step.find('.ug-step-title').text().trim();

        const content = step
            .find('p:not([class])')
            .map(function () {
                return $(this).text().trim();
            })
            .get()
            .join(' ');

        ugItems.push({
            id: index,
            title,
            content,
            element: step
        });
    });
};

const initFlexSearch = () => {
    flexIndex = new Document({
        document: {
            id: "id",
            store: true,
            index: [
                {
                    field: "title",
                    tokenize: "full",
                    weight: 2,
                    encoder: choosenCharset,
                    resolution: 9,
                    minLength: 3
                },
                {
                    field: "content",
                    tokenize: "full",
                    weight: 1,
                    encoder: choosenCharset,
                    resolution: 9,
                    minLength: 3
                }
            ]
        },
    });

    ugItems.forEach(item => flexIndex.add(item));

    bindSearchInput();
};

const toggleUGSteps = (hiddenSteps, shownSteps) => {
    hiddenSteps.hide();
    shownSteps.show();
};

const bindSearchInput = () => {
    $('#ug-search').on('input', function () {
        const query = $(this).val().trim().toLowerCase();

        clearHighlights();

        if (!query) {
            ugSteps.show();
            return;
        }

        const searchResults = flexIndex.search(query, {
            enrich: true,
        })
        const ids = searchResults.flatMap(group => group.result.map(r => r.id));

        const foundItems = ugItems.filter(item => ids.includes(item.id));
        const found = $(foundItems.map(item => item.element[0]));

        const hiddenSteps = ugSteps.not(found);
        const shownSteps = found;

        toggleUGSteps(hiddenSteps, shownSteps);

        applyHighlights(foundItems, query);
    });
};


$(document).ready(function () {
    initUGItems();
    initFlexSearch();
});